export class AppModalForm extends Component {
  constructor(props) {
    super(props);
    this.closebtn = null;
  }

  setCloseButton(closebtn) {
    this.closebtn = closebtn.current;
  }

  onSubmit(...args) {
    let { props } = this;
    props.onSubmit && props.onSubmit(...args,this.closebtn);
  }

  render() {
    let { props } = this;
    let { id = "appModal", title, onClose, open = true, closable = true,contentClass="w-3/6",dialogClass } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose", 'open', 'closable', 'onSubmit','dialogClass','notintable','contentClass','contentclass']);


    return (
      <AppModalBs
        id={id}
        title={title}
        contentClass={contentClass+" m-auto"}
        dialogClass={dialogClass}
        onClose={onClose}
        closable={closable}
        onLoad={({ closebtn }) => this.setCloseButton(closebtn)}
        ref="modal"
      >
        {open &&
          <AppFormData
            {...attrs}
            onSubmit={(...args) => this.onSubmit(...args)} >
          </AppFormData>
        }
      </AppModalBs>
    );
  }
}

export default AppModalForm;
